import icon from "../../assets/face-recognition.svg";
import type { Property } from "../../types";

export const faceRecognition: Property = {
  id: "faceRecognition",
  title: "faceRecognition.title",
  icon,
};
